import { object, oneOfType, string } from 'prop-types'
import { kuiperClassNames } from '../utils'

import './styles.scss'

const Popdown = ({ heading, content }) => (
  <div className={kuiperClassNames('popdown')}>
    <div className={kuiperClassNames('heading')}>{heading}</div>
    {content}
  </div>
)

Popdown.propTypes = {
  content: oneOfType([object, string]),
  heading: string,
}

export default Popdown
